import { allUpdateColumnList } from 'component/layout/Update/allUpdateColumnList';

/**
 * Column list for the SecurityUpdateListCard
 * for the "Updates" view.
 *
 * Excludes the "details" column since that would
 * link back to the current page.
 */
export const columnListUpdate = allUpdateColumnList.filter(
  column => column.key !== 'cveNumber'
);
